



















import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import {
  SaveServiceTaskTypeCommand,
  getServiceTaskType
  // TODO: APIが実装されたら切り替え
  // getServiceTaskType
} from "@/servicetask/api/service-tasks-api";
import ServiceTasksForm from "../../ui/components/ServiceTasksForm.vue";

@Component({
  components: {
    ServiceTasksForm
  }
})
export default class ServiceTasksEditPage extends Vue {
  @Prop({ required: true }) serviceTaskId!: string;

  taskType: SaveServiceTaskTypeCommand | null = {
    id: "",
    name: ""
  };

  saving = false;

  //ロード時の動作、変更の監視
  @Watch("serviceTaskId", { immediate: true })
  onServiceTaskChanged(serviceTaskId: string) {
    this.initServiceTask(serviceTaskId);
  }

  // APIから値の取得、表示
  async initServiceTask(serviceTaskId: string) {
    this.taskType = await getServiceTaskType(serviceTaskId);
  }

  goListPage() {
    this.$router.push({ path: "/admin/service-tasks" });
  }

  // APIへ値の保存 (ServiceTaskForm内のメソッドにまかせる)
  async saveServiceTask() {
    this.saving = true;
    const form = this.$refs["form"] as ServiceTasksForm;
    await form
      .submit()
      .then(() => {
        this.goListPage();
      })
      .catch((e: Error) => {
        alert(e.message);
      })
      .finally(() => {
        this.saving = false;
      });
  }
}
